import { gql } from '@apollo/client'
import { NOTIFICATION_FIELDS } from './fragments/notification'

export const COMPLETE_NOTIFICATION = gql`
  ${NOTIFICATION_FIELDS}
  mutation completeNotification($id: ID!) {
    completeNotification(id: $id) {
      ...NotificationFields
    }
  }
`
